import type { Option } from '@/legacy/types';

export const COMPANY_AVATAR_CLASSES = [
	'bg-company-avatar-1',
	'bg-company-avatar-2',
	'bg-company-avatar-3',
	'bg-company-avatar-4',
	'bg-company-avatar-5',
	'bg-company-avatar-6',
	'bg-company-avatar-7',
	'bg-company-avatar-8',
	'bg-company-avatar-9',
	'bg-company-avatar-10',
] as const;

export const COMPANY_AVATAR_FALLBACK_CLASS = 'bg-secondary-light'; // existing token, used while color unresolved

/**
 * Index by POSITION in the companies list, NOT `companyId % 10` — position-based guarantees no
 * two companies a user can see share a color (for lists <= 10); modulo on the raw id does not
 * (e.g. ids 123 and 133 would collide).
 *
 * -1 when the list hasn't resolved yet or the company isn't found in it.
 */
export const findCompanyColorIndex = (
	companies: Pick<Option, 'value'>[] | undefined,
	companyId: number | null | undefined,
): number =>
	companies && companyId != null ? companies.findIndex((c) => c.value === companyId) : -1;

export const getCompanyAvatarClass = (index: number): string =>
	index < 0
		? COMPANY_AVATAR_FALLBACK_CLASS
		: (COMPANY_AVATAR_CLASSES[index % COMPANY_AVATAR_CLASSES.length] ??
			COMPANY_AVATAR_FALLBACK_CLASS);
